import { BiometryType } from '@capgo/capacitor-native-biometric';

const setPepperMerchantLogin = (pepperMerchantLogin: boolean) => localStorage.setItem('pepperMerchantLogin', pepperMerchantLogin ? 'true' : 'false');
const hasPepperMerchantLogin = () => localStorage.getItem('pepperMerchantLogin') === 'true';

const setAGCode = (AGCode: boolean) => localStorage.setItem('proposalReference', AGCode ? 'true' : 'false');
const hasAGCode = () => localStorage.getItem('proposalReference') === 'true';

const getOnboardingStorage = () => localStorage.getItem('merchants_first_time');
const setOnboardingSeen = () => localStorage.setItem('merchants_first_time', 'false');

const getBiometrySaved = () => {
  const biometry = localStorage.getItem('merchanBiometrySaved');
  if (biometry !== null) {
    return parseInt(biometry, 10) as BiometryType;
  }
  return null;
};
const setBiometrySaved = (
  type: BiometryType,
) => localStorage.setItem('merchanBiometrySaved', type.toString());
const clearBiometrySaved = () => localStorage.removeItem('merchanBiometrySaved');

const setSuperExpress = (activate: boolean) => localStorage.setItem('superExpressFlow', activate.toString());
const hasSuperExpress = () => (localStorage.getItem('superExpressFlow') === 'true' ? true : localStorage.getItem('superExpressFlow') === 'false' ? false : null);

const setNotificationPermissions = (permissions: string) => localStorage.setItem('notificationPermissions', permissions);
const getNotificationPermissions = () => localStorage.getItem('notificationPermissions');

const setFcmToken = (token: string) => localStorage.setItem('fcmToken', token);
const getFcmToken = () => localStorage.getItem('fcmToken');
const removeNotificationToken = () => localStorage.removeItem('fcmToken');

const setDeviceId = (deviceId: string) => localStorage.setItem('deviceId', deviceId);
const getDeviceId = () => localStorage.getItem('deviceId');

const initialNotificationRequested = () => localStorage.setItem('initialNotificationRequested', 'true');
const getInitialNotificationRequested = () => localStorage.getItem('initialNotificationRequested') === 'true';

const setEntryUserChop = (user: string) => sessionStorage.setItem('pepper-user-chop', user);
const getEntryUserChop = () => sessionStorage.getItem('pepper-user-chop');
const clearEntryUserChop = () => sessionStorage.removeItem('pepper-user-chop');

// En sessionStorage para que se limpie con la sesión (TokenService.clearSession)
const setMustChangePassword = () => sessionStorage.setItem('mustChangePassword', 'true');
const getMustChangePassword = () => sessionStorage.getItem('mustChangePassword') === 'true';
const clearMustChangePassword = () => sessionStorage.removeItem('mustChangePassword');

export const storageService = {
  setPepperMerchantLogin,
  hasPepperMerchantLogin,
  setAGCode,
  hasAGCode,
  getOnboardingStorage,
  setOnboardingSeen,
  getBiometrySaved,
  setBiometrySaved,
  clearBiometrySaved,
  setSuperExpress,
  hasSuperExpress,
  setNotificationPermissions,
  getNotificationPermissions,
  removeNotificationToken,
  setFcmToken,
  getFcmToken,
  // setNotificationsEnabled,
  // getNotificationsEnabled,
  setDeviceId,
  getDeviceId,
  initialNotificationRequested,
  getInitialNotificationRequested,
  setEntryUserChop,
  getEntryUserChop,
  clearEntryUserChop,
  setMustChangePassword,
  getMustChangePassword,
  clearMustChangePassword,
};
